import RpcClass from "../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.Integrations';

import LocalDate from "../../../../server/LocalDate.js";
import LocalDateTime from "../../../../server/LocalDateTime.js";
import LocalTime from "../../../../server/LocalTime.js";



class Integrations extends RpcClass{

    /**
     *  @class Integrations
     *  @alias module:src/server/com/silkplm/rpc/Integrations.Integrations
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param clazzName {string} 
     * @param extId {string} 
     * @param extSystem {string} 
     * @param silkId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     clearMapping(clazzName, extId, extSystem, silkId) {
            return RpcClass.rpcCall('/rpc/integrations/clear-mapping', [clazzName, extId, extSystem, silkId]);
    }
    /** 
     * @async
     * @param silkId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     decodedSilkId(silkId) {
            return RpcClass.rpcCall('/rpc/integrations/decoded-silk-id', [silkId]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param extId {string} 
     * @param extSystem {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/integrations/IdMapping.IdMapping>}
     */
     externalIdToSilk(clazzName, extId, extSystem) {
            return RpcClass.rpcCall('/rpc/integrations/external-id-to-silk', [clazzName, extId, extSystem]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param silkId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/integrations/IdMapping.IdMapping[]>}
     */
     findBindingsWithExternalIds(clazzName, silkId) {
            return RpcClass.rpcCall('/rpc/integrations/find-bindings-with-external-ids', [clazzName, silkId]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/IntegrationBusParameters.IntegrationBusParameters>}
     */
     integrationBusAccess() {
            return RpcClass.rpcCall('/rpc/integrations/integration-bus-access', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     integrationEnabled() {
            return RpcClass.rpcCall('/rpc/integrations/integration-enabled', []);
    }
    /** 
     * @async
     * @param extSystemId {string} 
     * @param eventType {string} 
     * @param eventSubType {string} 
     * @param eventData {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     notify(extSystemId, eventType, eventSubType, eventData) {
            return RpcClass.rpcCall('/rpc/integrations/notify', [extSystemId, eventType, eventSubType, eventData]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param silkId {string} 
     * @param extSystem {string} 
     * @param keyName {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     readObjectData(clazzName, silkId, extSystem, keyName) {
            return RpcClass.rpcCall('/rpc/integrations/read-object-data', [clazzName, silkId, extSystem, keyName]);
    }
    /** 
     * @async
     * @param userId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     resetToken(userId) {
            return RpcClass.rpcCall('/rpc/integrations/reset-token', [userId]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param extId {string} 
     * @param extSystem {string} 
     * @param silkId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     setMapping(clazzName, extId, extSystem, silkId) {
            return RpcClass.rpcCall('/rpc/integrations/set-mapping', [clazzName, extId, extSystem, silkId]);
    }
    /** 
     * @async
     * @param userId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     showToken(userId) {
            return RpcClass.rpcCall('/rpc/integrations/show-token', [userId]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param silkId {string} 
     * @param extSystem {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/integrations/IdMapping.IdMapping>}
     */
     silkIdToExternalId(clazzName, silkId, extSystem) {
            return RpcClass.rpcCall('/rpc/integrations/silk-id-to-external-id', [clazzName, silkId, extSystem]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param extSystem {string} 
     * @param silkId {string} 
     * @param keyName {string} 
     * @param rawJson {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     storeObjectData(clazzName, extSystem, silkId, keyName, rawJson) {
            return RpcClass.rpcCall('/rpc/integrations/store-object-data', [clazzName, extSystem, silkId, keyName, rawJson]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.Integrations';
metadata.__type_short__ = 'Integrations';
Integrations.prototype.__metadata__ = metadata;

Integrations.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/Integrations */
export default Integrations

export { Integrations }
